/**
 * @bc/client-shared
 *
 * Shared utilities and types for client applications (client and bcc).
 * Contains logic that can be reused across different UI implementations.
 */


// =============================================================================
// client-shared - Main Entry Point
// =============================================================================
//
// Import providers directly from their paths:
//   import { useSFDCAuthState } from '@client-shared/providers/auth';
//   import { useVendorContext } from '@client-shared/providers/vendor';
//
// =============================================================================
// Utils
export * from "./utils";

// Types
export * from "./types";
// Re-export lib utilities
export * from './lib';

// Re-export services API
export * from './services/api';

// Re-export utilities
export * from './utilities';

